export var getTag = function getTag(onClick, href) {
  if (href) {
    return 'a';
  }
  if (onClick) {
    return 'button';
  }
  return 'div';
};